import { MinzeElement, Reactive, EventListeners } from 'minze'
import { config, MODALS } from '../../../constants'
import MainModule from '../../../modules/main'
import { Locale } from '../../../modules/locale'
import { Routing } from '../../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'partnerProfile', {
  title: 'Profil Partenaire',
  previous: 'Précédent',
})

Locale.getInstance().registerKeySet('en', 'partnerProfile', {
  title: 'Partner Profile',
  previous: 'Previous',
})

export interface LvcPartnerProfileModalWrapper {}

export class LvcPartnerProfileModalWrapper extends MinzeElement {
  modalId = MODALS.PARTNER_PROFILE_MODAL
  _authHandler: any = null

  handleAuthChanged = async (data: any): Promise<void> => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()
    const isPartner = await mainModule.getAuth().isPartner()

    // if he is not a partner, redirect to home
    if (data?.isLoggedIn && !isPartner) {
      routing.goTo(Routing.ROUTES[lang].home)
    }
  }

  async onReady(): Promise<void> {
    const mainModule = MainModule.getInstance()
    this._authHandler = this.handleAuthChanged.bind(this)
    mainModule.getEE().on('lvc:user_state_changed', this._authHandler.bind(this))
    this.handleAuthChanged({ isLoggedIn: await mainModule.getAuth().isLoggedIn() })
  }

  goBack = () => {
    const lang = MainModule.getInstance().getLang() as 'fr' | 'en'
    window.location.href = config.proSpaceUrl[lang]
  }

  html = () => `
    <lvc-modal is-fullscreen-modal-scrollable="true" is-fixed="false" left-title="true" modal-title="${Locale.getKey('partnerProfile.title')}" modal-id="${this.modalId}" background="linear-gradient(to top left, #42f7a3, rgba(255, 153, 150, 0), #8997ff), linear-gradient(to top right, #b0dee2,rgba(255, 153, 150, 0), #01c0b6) rgba(70,205,209,255)" narrow="true">
      <div slot="lvc-modal-top">
        <lvc-box color="#1E007D" display="flex" alignItems="center" id="link-back">
          <lvc-chevron-left-icon></lvc-chevron-left-icon>
          <lvc-box mt="-4px">
            <lvc-text font-preset="small">
              ${Locale.getKey('partnerProfile.previous')}
            </lvc-text>
          </lvc-box>
        </lvc-box>
      </div>
      <div slot="lvc-modal-content">
        <lvc-partner-profile-modal-content></lvc-partner-profile-modal-content>
      </div>
      
    </lvc-modal>
  
  `

  css = () => `
    :host {
    }

    #link-back {
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  `

  eventListeners: EventListeners = [['#link-back', 'click', this.goBack]]
}
